'use strict';

var $ = require('jquery'),
    progress = require('./progress'),
    util = require('./util');

var currentRequests = [];

/**
 * @function
 * @description Ajax request to get json response
 * @param {Boolean} async  Asynchronous or not
 * @param {String} url URI for the request
 * @param {Object} data Name/Value pair data request
 * @param {Function} callback  Callback function to be called
 */
var getJson = function (options) {
    options.url = util.toAbsoluteUrl(options.url);
    // return if no url exists or url matches a current request
    if (!options.url || currentRequests[options.url]) {
        return;
    }

    currentRequests[options.url] = true;

    // make the server call
    /*jslint unparam: true */
    $.ajax({
        dataType: 'json',
        url: options.url,
        async: options.async === undefined || options.async === null ? true : options.async,
        data: options.data || {}
    })
        .done(function (response) {
            // success
            if (options.callback) {
                options.callback(response);
            }
        })
        .fail(function (xhr, textStatus) {
            // failed
            if (textStatus === 'parsererror') {
                /*eslint-disable no-alert */
                window.alert(Resources.BAD_RESPONSE);
                /*eslint-enable no-alert */
            }
            if (options.callback) {
                options.callback(null);
            }
        })
        .always(function () {
            // executed on success or fail
            // remove current request from hash
            if (currentRequests[options.url]) {
                delete currentRequests[options.url];
            }
        });
    /*jslint unparam: false */
};
/**
 * @function
 * @description ajax request to load html response in a given container
 * @param {String} url URI for the request
 * @param {Object} data Name/Value pair data request
 * @param {Function} callback  Callback function to be called
 * @param {Object} target Selector or element that will receive content
 */
var load = function (options) {
    options.url = util.toAbsoluteUrl(options.url);
    // return if no url exists or url matches a current request
    if (!options.url || currentRequests[options.url]) {
        return;
    }

    currentRequests[options.url] = true;

    // make the server call
    /*jslint unparam: true */
    $.ajax({
        dataType: 'html',
        url: util.appendParamToURL(options.url, 'format', 'ajax'),
        data: options.data,
        xhrFields: {
            withCredentials: true
        }
    })
        .done(function (response) {
            // success
            if (options.target) {
                $(options.target).empty();
                if (typeof options.target === 'string') {
                    $(options.target).html(response);
                } else if (options.target.length) {
                    options.target[0].innerHTML = response;
                }
            }
            if (options.callback) {
                options.callback(response);
            }
        })
        .fail(function (xhr, textStatus) {
            // failed
            if (textStatus === 'parsererror') {
                /*eslint-disable no-alert */
                window.alert(Resources.BAD_RESPONSE);
                /*eslint-enable no-alert */
            }
            options.callback(null, textStatus);
        })
        .always(function () {
            progress.hide();
            // remove current request from hash
            if (currentRequests[options.url]) {
                delete currentRequests[options.url];
            }
        });
    /*jslint unparam: false */
};

var submitForm = function ($form, callback, keepProgress) {
    var formData = $form.serialize();
    var $submitButton = $form.find('button[type="submit"]');
    var url = util.appendParamToURL($form.attr('action'), 'format', 'ajax');

    $.ajax({
        url: url,
        method: $form.attr('method'),
        data: formData + '&' + encodeURI($submitButton.attr('name')) + '=' + encodeURI($submitButton.attr('value')),
        xhrFields: {
            withCredentials: true
        }
    })
        .done(function (response) {
            callback(response);
        })
        .fail(function (xhr, textStatus) {
            if (textStatus === 'parsererror') {
                /*eslint-disable no-alert */
                window.alert(Resources.BAD_RESPONSE);
                /*eslint-enable no-alert */
            }
            callback(null, textStatus);
        })
        .always(function () {
            if (!keepProgress) {
                progress.hide();
            }
            if (currentRequests[url]) {
                delete currentRequests[url];
            }
        });
};

exports.getJson = getJson;
exports.load = load;
exports.submitForm = submitForm;
